import { render, staticRenderFns } from "./CartCardBasicData.vue?vue&type=template&id=f2671dd6&scoped=true"
import script from "./CartCardBasicData.vue?vue&type=script&lang=ts"
export * from "./CartCardBasicData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2671dd6",
  null
  
)

export default component.exports